export var defaultFontSizes = [
    13,
    14,
    15,
    16,
    17,
    18,
    19,
    20,
    21,
    22,
    23,
    24,
    25,
    26,
    27,
    28,
    29,
    30,
    31,
    32,
    33,
    34,
    36,
    38,
    40,
    42
];
export var defaultButtonList = [
    [
        'fontSize',
        'bold',
        'italic',
        'underline',
        'fontColor',
        'removeFormat',
        'table',
        'link',
        'image'
    ]
];
export var defaultColorList = ['#DD2A49', '#252525'];
